import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import GoAutoWarrantyWrapper from "@components/layouts/goAutoWarrantyWrapper";

import { getPageProps } from "@services/initial-calls";
import PrivacyPolicy from "@components/shared/legal/privacyPolicy";

export default function GoAutoWarrantyHome(): ReactElement {
    return (
        <GoAutoWarrantyWrapper>
            <PrivacyPolicy
                category="GoAutoWarranty"
                domain="GoAutoWarranty.com"
            />
        </GoAutoWarrantyWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", { pageTitle: "Privacy Policy" });
};
